import React, { memo, useMemo } from "react";

import { CustomInput } from "components";
import { FieldWithReadOnlyMode } from "components/formFields";
import { hasPermissions, viewSensitiveDataFullPermissionSet } from "helpers";
import {
	exactNumberAndLettersOfDigitsMask11,
	normalizeAll,
	required,
	trimNormalizer,
	validateSwiftBic,
} from "validators";

type SwiftFieldProps = {
	loading: boolean;
	value: string | undefined;
	isEditable: boolean;
};

const SwiftField = ({ loading, value, isEditable }: SwiftFieldProps) => {
	const isFieldEditable = useMemo(
		() => isEditable && hasPermissions(viewSensitiveDataFullPermissionSet),
		[isEditable],
	);

	return (
		<FieldWithReadOnlyMode
			label="SWift BIC"
			component={CustomInput}
			smLabel={5}
			smSelect={7}
			type="text"
			validate={[required, validateSwiftBic]}
			normalize={normalizeAll([exactNumberAndLettersOfDigitsMask11])}
			name={"swift_bic"}
			blurLoading={loading}
			normalizeOnBlur={trimNormalizer}
			readOnlyProps={{
				isEditable: isFieldEditable,
				value,
			}}
		/>
	);
};

const component = memo(SwiftField);
export { component as SwiftField };
